import React from "react";
import { Dropdown } from "./dropdown";

function Card({ plan, onOpenModal }) {
  const [statusStyle, setStatusStyle] = React.useState(getStatusStyle(plan.assistance.status));

  function getStatusStyle(assistanceStatus) {
    if (assistanceStatus === null) {
      return "primary"; // Sin definir - Violeta
    } else if (assistanceStatus === true) {
      return "success"; // Asistirá - Verde
    } else if (assistanceStatus === false) {
      return "secondary"; // Canceló - Gris
    }
  }

  let teachers = ''
  for(let i=0; i<plan.activities.length; i++) {
    teachers += `${plan.activities[i].teacher.name}\n`
  }

  return (
    <div className="col-12 col-sm-6 col-md-6 col-xl-3 grid-margin stretch-card">
      <div className={`card side-edge-${statusStyle}`}>
        <div className="card-body">
          <div className="d-flex justify-content-between">
            <h4 className="card-title">
              {plan.title}
              <p className="font-weight-medium text-dark text-small">
                {plan.date}
              </p>
            </h4>
            <Dropdown 
              plan={plan.id}
              assistance={plan.assistance}
              statusStyle={statusStyle} 
              setStatusStyle={setStatusStyle} 
              getStatusStyle={getStatusStyle}
              onOpenModal={onOpenModal}
            />
          </div>
          <div className="row pt-3 mt-md-1 border-top">
            <div className="col">
              <div className="d-flex purchase-detail-legend align-items-center">
                <div>
                  <p className="font-weight-medium text-dark text-small">
                    Teachers
                  </p>
                  <h3 className="font-weight-bold text-dark  mb-0">
                    {teachers}
                  </h3>
                </div>
              </div>
            </div>
            <div className="col">
              <div className="d-flex purchase-detail-legend align-items-center">
                <div>
                  <p className="font-weight-medium text-dark text-small">
                    Duration - {plan.duration}
                  </p>
                  <h3 className="font-weight-bold text-dark  mb-0">
                    {plan.durationRange}
                  </h3>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export { Card }